import React from 'react'

interface IconProps {
  size?: number
  color?: string
  strokeWidth?: number
  className?: string
}

export const AccountCardIcon: React.FC<IconProps> = ({
  size = 20,
  color = 'rgb(248, 248, 249)',
  strokeWidth = 2,
  className = '',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ color, opacity: 0.9 }}
    >
      {/* ID Card */}
      <rect x="2" y="4" width="20" height="16" rx="2" />

      {/* User photo area */}
      <circle cx="8" cy="10" r="2.5" />

      {/* Text lines */}
      <path d="M13 8H19" />
      <path d="M13 12H19" />
      <path d="M13 16H16" />

      {/* Card details */}
      <path d="M6 16H10" />
    </svg>
  )
}

export default AccountCardIcon
